export default __webpack_public_path__ + "static/media/L_Leao.5e0c997c.mp3";